import Barcode from "./pages/OnBoard";
import Layout from "./Layout";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RouteGuard from "./components/RouteGuard";
import {
  Overview,
  NewOrder,
  AwaitingCourier,
  OutOfDelivery,
  CancelledOrders,
  ToDo,
  DropOff,
} from "./pages";
import Employees from "./pages/Employees";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WebPubSubClient } from "@azure/web-pubsub-client";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setWebSocketClient, setWebSocketMessage } from "./features/webSocketSlice";

function App() {

  const webSocketUrl = useSelector(state => state.websocket.webSocketResponse)
  const role = sessionStorage.getItem("Role");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!webSocketUrl) return;  
  
    let groupName = role === "Arz" ? "CashPickup-Arz" : "CashPickup-Employee";

    const webSocketClient = new WebPubSubClient(`${webSocketUrl}`);

    webSocketClient.on("connected", () => {
        console.log("WebSocket connected");
  
        webSocketClient.joinGroup(groupName)
            .then(() => {
                console.log(`Joined group: ${groupName}`);
            })
            .catch((error) => {
                console.error("Failed to join group:", error);
            });
    });
  
    webSocketClient.on("group-message", (message) => {
      if (message) {
        if (role === "Employee") {
          toast.info("New Notification: New Order");
        }
        dispatch(setWebSocketMessage(message));
        console.log("Message received:", message);
      } else {
        console.error("Failed to receive message");
      }
    });
    
  
    webSocketClient.on("disconnected", () => {
        console.log("WebSocket disconnected");
    });
  
    webSocketClient.on("error", (error) => {
        console.error("WebSocket error:", error);
        toast.error(`WebSocket Error: ${error.message}`);
    });
  
    webSocketClient.start()
        .then(() => {
            console.log("WebSocket client started");
            dispatch(setWebSocketClient(webSocketClient));
        })
        .catch((err) => {
            console.error("Error starting WebSocket client:", err);
        });
  
    return () => {
      webSocketClient.stop();
    };
  }, [webSocketUrl, role]);  


  return (
    <>
      <ToastContainer 
        autoClose={false} 
        closeOnClick={false} 
        hideProgressBar={true} 
      />
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Barcode />} />
          <Route path='overview' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<Overview />} />
          </Route>
          <Route path='todo' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<ToDo />} />
          </Route>
          <Route path='neworder' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<NewOrder />} />
          </Route>
          <Route path='awaitcourier' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<AwaitingCourier />} />
          </Route>
          <Route path='outfordelivery' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<OutOfDelivery />} />
          </Route>
          <Route path='canceled' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<CancelledOrders />} />
          </Route>
          <Route path='dropoff' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<DropOff />} />
          </Route>
          <Route path='employees' element={<RouteGuard children={<Layout />} />}>
            <Route index element={<Employees />} />
          </Route>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
